<template>
    <frm-modal-component ref="modal" data-testid="select-zorgmail-account" @save="save()">
        <template #header>
            {{ $t('fysioroadmap.reports.select_zorgmail_account') }}
        </template>

        <form>
            <ul class="zorgmail-accounts">
                <li v-for="zorgmailAccount in zorgmailAccounts" :key="zorgmailAccount.value">
                    <label>
                        <input
                            v-model="zorgmailAccountId"
                            type="radio"
                            name="zorgmail_account"
                            :value="zorgmailAccount.value"
                        >
                        {{ zorgmailAccount.label }}
                    </label>
                </li>
            </ul>
        </form>
    </frm-modal-component>
</template>

<script>
import HandlesZorgmailAccount from '../../mixins/HandlesZorgmailAccount';

export default {
    mixins: [HandlesZorgmailAccount],

    methods: {
        save() {
            this.$refs.modal.closeModal(this.zorgmailAccountId);
        },
    },
};
</script>

<style scoped lang="scss">
.zorgmail-accounts {
  list-style: none;
  padding: 0;

  li {
    &:not(:last-child) {
      border-bottom: 1px solid $color__primary--background-highlight;
    }
  }

  label {
    background: white;
    cursor: pointer;
    display: block;
    padding: rhythm(1);
  }
}
</style>
